import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {WheelNewsOrder, Response} from '../models/models';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WheelNewsOrderService {

  constructor(private httpClient: HttpClient) {}

  getOrdersForWheelnewsOrderview(rightId: number, partnerId: string): Observable<Response<WheelNewsOrder[]>> {
    return this.httpClient.get<Response<WheelNewsOrder[]>>(environment.apiPath + 'WheelNewsOrder/' + rightId + '/RightId/' + partnerId + '/PartnerId');
  }

  generatePdfByOrderIds(orderIds: number[]): Observable<Response<[]>> {
    let orderIdsString = '';
    orderIds.forEach(o => { orderIdsString += o + ','; });
    if (orderIdsString.length > 0) { orderIdsString.substr(orderIdsString.length, 1); }
    return this.httpClient.get<Response<[]>>(environment.apiPath + 'WheelNewsOrder/' + orderIds + '/GeneratePdfs');
  }

  insertOrder(order: WheelNewsOrder): Observable<Response<WheelNewsOrder[]>> {
    return this.httpClient.post<Response<WheelNewsOrder[]>>(environment.apiPath + 'WheelNewsOrder/', order);
  }

  validateClient(order: WheelNewsOrder): Observable<Response<WheelNewsOrder>> {
    return this.httpClient.post<Response<WheelNewsOrder>>(environment.apiPath + 'WheelNewsOrder/Validate/Client', order);
  }

  validateSender(order: WheelNewsOrder): Observable<Response<WheelNewsOrder>> {
    return this.httpClient.post<Response<WheelNewsOrder>>(environment.apiPath + 'WheelNewsOrder/Validate/Sender', order);
  }

  validateRecipient(order: WheelNewsOrder): Observable<Response<WheelNewsOrder>> {
    return this.httpClient.post<Response<WheelNewsOrder>>(environment.apiPath + 'WheelNewsOrder/Validate/Recipient', order);
  }

  validateRimsets(order: WheelNewsOrder): Observable<Response<WheelNewsOrder>> {
    return this.httpClient.post<Response<WheelNewsOrder>>(environment.apiPath + 'WheelNewsOrder/Validate/Rimsets', order);
  }
}
